import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    modals: {},
  },
  mutations: {
    showModal(state, { id, payload }) {
      Vue.set(state.modals, id, {
        show: true,
        title: payload.title,
        text: payload.text,
        confirmButtonText: payload.confirmButtonText,
        cancelButtonText: payload.cancelButtonText,
        onConfirm: payload.onConfirm || null,
        onCancel: payload.onCancel || null,
      });
    },
    hideModal(state, id) {
      if (state.modals[id]) {
        state.modals[id].show = false;
      }
    },
  },
  actions: {
    showModal({ commit }, { id, payload }) {
      commit('showModal', { id, payload });
    },
    hideModal({ commit }, id) {
      commit('hideModal', id);
    },
  },
};